<template>
  <nav :class="style.secondPartTable">
    <div :class="style.heading">
      <h4
        ref="titleElement"
        :class="{[style.headingTitleOverflowing]: isTitleOverflowing}"
        :style="titleStyle"
        @mouseenter="updateTitleOverflow"
      >
        <span ref="titleTextElement" :class="style.headingTitleText">
          {{ title }}
        </span>
      </h4>
    </div>

    <TabStyle
      v-for="item in navList"
      :key="item.value as string"
      :active="isActive(item.value as string)"
      :icon="item.icon"
      :text="item.text"
      :disabled="item?.disabled"
      @click="item.handler"
    />
  </nav>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "../NavLayoutNew.module.scss";
import TabStyle from "@/elements/UI/tabs/TabStyle/TabStyle.vue";

export default defineComponent({
  name: "NavSecondaryPart",
  components: {
    TabStyle
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    navList: {
      type: Array as PropType<ListActionItem[]>,
      required: true
    },
    activeGroup: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      style,
      isTitleOverflowing: false,
      titleShift: "0px",
      titleTransitionDuration: "0ms"
    };
  },

  computed: {
    titleStyle(): Record<string, string> {
      return {
        "--title-shift": this.titleShift,
        "--title-marquee-duration": this.titleTransitionDuration
      };
    }
  },

  watch: {
    title(): void {
      this.$nextTick(this.updateTitleOverflow);
    }
  },

  mounted() {
    this.$nextTick(this.updateTitleOverflow);
    window.addEventListener("resize", this.updateTitleOverflow);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.updateTitleOverflow);
  },

  methods: {
    isActive(group: string): boolean {
      return this.activeGroup === group;
    },

    updateTitleOverflow(): void {
      const titleElement = this.$refs.titleElement as HTMLElement | undefined;
      const titleTextElement = this.$refs.titleTextElement as
        HTMLElement | undefined;

      if (!titleElement || !titleTextElement) {
        return;
      }

      const hiddenWidth =
        titleTextElement.scrollWidth - titleElement.clientWidth;
      const isOverflowing = hiddenWidth > 1;

      this.isTitleOverflowing = isOverflowing;
      this.titleShift = isOverflowing ? `-${hiddenWidth}px` : "0px";
      this.titleTransitionDuration = isOverflowing
        ? `${Math.min(Math.max(hiddenWidth * 35, 700), 4000)}ms`
        : "0ms";
    }
  }
});
</script>
